import { Card } from 'primereact/card';
import { ConfigurationForm } from './ConfigurationForm/ConfigurationForm';
import { AnalysisConfig } from '@/api/domains/analyses';
import styles from '../AnalysisWizardSteps.module.css';
import { Button } from 'primereact/button';
import { ANALYSIS_ENABLED } from '@/config/features';

interface StepConfigurationProps {
  config: AnalysisConfig;
  onChangeConfig: (config: AnalysisConfig) => void;
  handleBack: () => void;
  handleSubmit: () => void;
  isLoading: boolean;
}

const StepConfiguration = ({
  config,
  onChangeConfig,
  handleBack,
  handleSubmit,
  isLoading
}: StepConfigurationProps) => {
  return (
    <Card>
      <ConfigurationForm config={config} onChange={onChangeConfig} />
      <div className={styles.stepActions}>
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          onClick={handleBack}
          className={styles.textButton}
          disabled={isLoading}
        />
        <Button
          label={
            isLoading
              ? 'Creating...'
              : ANALYSIS_ENABLED
                ? 'Create Analysis'
                : 'Disabled'
          }
          icon={isLoading || !ANALYSIS_ENABLED ? undefined : 'pi pi-check'}
          iconPos="right"
          onClick={handleSubmit}
          loading={isLoading}
          disabled={isLoading || !ANALYSIS_ENABLED}
          className={styles.primaryButton}
          tooltip={
            !ANALYSIS_ENABLED
              ? 'Feature disabled in this deployment'
              : undefined
          }
          tooltipOptions={{ position: 'top' }}
        />
      </div>
    </Card>
  );
};

export default StepConfiguration;
